import { c as _c } from "react/compiler-runtime";
export type HelpMeChoosePageProps = {
  header?: string;
  description?: string;
  answers?: React.ReactNode;
};
export const HelpMeChoosePage: React.FC<HelpMeChoosePageProps> = t0 => {
  const $ = _c(10);
  const {
    header,
    description,
    answers
  } = t0;
  let t1;
  if ($[0] !== header) {
    t1 = <h1 className="heading-sm heading-neutral-amplified">{header}</h1>;
    $[0] = header;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = <p className="label-moderate label-lg my-snug-lg">{description}</p>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== answers) {
    t3 = <div className="flex flex-col lg:flex-row gap-comfy-sm mt-comfy-lg md:mt-roomy-sm justify-center">{answers}</div>;
    $[4] = answers;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="HelpMeChoose__page">{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};